<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        결제 이력
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">이력</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">결제</a>
        </li>
      </ul>
    </div>
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">지불 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">시스템</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <div class="checkbox-switch">
              <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label size="sm" v-model="so.opt['admin_id']" @change="change">
              <div class="checkbox-animate disabled">
                <span class="checkbox-off">OFF</span>
                <span class="checkbox-on">ON</span>
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_group">그룹 이름</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="true" v-model="group_name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-else class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_search_group" :variant="group_name ? 'primary' : 'add'" @click="chainGroup = true">그룹 선택</b-button>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_partner">파트너 이름</label>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-input @keydown.enter="refresh" type="text" :disabled="true" v-model="partner_name"></b-form-input>
        </b-col>
        <b-col v-if="partner_name" class="col-xl-1 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('partner')">초기화</b-button>
          </b-form-group>
        </b-col>
        <b-col v-else class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-button size="sm" id="ph_search_partner" :variant="partner_name ? 'primary' : 'add'" @click="chainPartner = true">파트너 선택</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-2">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" @change="refresh" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 1rem"></span>{{model.total.toString().padStart(10, nbsp) | dollar}}</span>
        <br>
        <span class="badge badge_border_info mb-2">사용 : <span style="padding-left: 1rem"></span>{{model.system.toString().padStart(10, nbsp) | dollar}}</span>
      </b-col>
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk">
              <option disabled value="">검색</option>
              <option value="admin_id">시스템</option>
              <option value="partner.username">파트너</option>
              <option value="group.groupname">그룹</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" :disabled="so.adv || so.sk == 'admin_id'" v-model="so.sv" @keyup.enter="refresh">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">
              {{ row.item.created_at | datetime}}
            </template>
            <template slot="admin" slot-scope="row">
              {{row.item.admin ? row.item.admin.username : 'System'}}
            </template>
            <template slot="partner" slot-scope="row">
              {{row.item.partner && row.item.partner.username ? row.item.partner.username : '-'}}
            </template>
            <template slot="group" slot-scope="row">
              {{row.item.group && row.item.group.groupname ? row.item.group.groupname : '-'}}
            </template>
            <template slot="method" slot-scope="row">
              <span> {{row.item.method || '-'}} </span>
              <!-- <b-badge style="cursor:pointer" @click="modal_history(row.item.history)" v-if="row.item.is_paid == false && row.item.total_paid" variant="primary">?</b-badge> -->
            </template>
            <template slot="credit_amount" slot-scope="row">
              <span> {{row.item.credit_amount | dollar}} </span>
              <!-- <b-badge style="cursor:pointer" @click="modal_history(row.item.history)" v-if="row.item.is_paid == false && row.item.total_paid" variant="primary">?</b-badge> -->
            </template>
            <template slot="func" slot-scope="row">
              <!-- <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn> -->
              <b-btn @click="modal_history(row.item)" size="sm" class="btn btn-sm btn-insert">선택</b-btn>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-row class="mt30">
      <b-col class="pagination justify-content-center">
        <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
      </b-col>
    </b-row>

    <!-- start modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-only cancel-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
    <!-- start modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="Find then Partner and Select" size="xl" v-model="chainPartner" @ok="chainPartner = false" ok-only cancel-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setPartner"></partner-List>
    </b-modal>
    <!-- start modal -->
    <b-modal class="modal-dialog modal-dialog-centered" title="상세 정보" size="x"  v-model="confirm_payment_history" @ok="confirm_payment_history = false" ok-only cancel-variant="primary">
      <!-- {"purchased_at":"2020-07-30T05:20:58.965844Z","action":"partner payment","pg_name":"f1","pg":"credit","price":10.0} -->
      <table class="table table-sm table-striped" v-if="payment_history">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">상세 설명</th>
          </tr>
        </thead>
        <!-- {"is_add":false,"invoice_id":"cf22279b-7bbd-406c-b3ef-b0f321786ac7","to":"test_hdh_01","to_credit":0.00,"from":"hdh+partner1+09@f1security.co.kr","from_credit":26.26,"reason":"Completes payment with credit"} -->
        <tbody>
          <tr>
            <th scope="row">청구서</th>
            <td>
              <!-- <a style="cursor:pointer;color:skyblue;" v-if="payment_history.invoice_id" @click="$router.push({ name : 'invoice', params : { invoice_id : payment_history.invoice_id } })"> -->
              <a style="cursor:pointer;color:skyblue;" v-if="payment_history.invoice_id" @click="$router.push({ name : 'InvoiceGroup', params : { invoice_id : payment_history.invoice_id } })">
                {{payment_history.invoice_id}}
              </a>
              <span v-else>-</span>
            </td>
          </tr>
          <tr>
            <th scope="row">관리자(시스템)</th>
            <td>
              {{payment_history.from || '-'}}
              ({{payment_history.from_credit | dollar}})
            </td>
          </tr>
          <tr>
            <th scope="row">회사명</th>
            <td>
              {{payment_history.to || '-'}}
              ({{payment_history.to_credit | dollar}})
            </td>
          </tr>
          <tr>
            <th scope="row">비용</th>
            <td>
              {{payment_history.credit_amount | dollar}}
            </td>
          </tr>
          <tr>
            <th scope="row">이유</th>
            <td>
              {{payment_history.reason || '-'}}
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>